// @flow
import * as api from './api';
import * as factories from './factories';

export const OrganizationModel = {
  ...api,
  ...factories,
};
